import { ORIGIN } from 'edrolo/constants/Analytics';
import { track } from 'edrolo/analytics';
import { Link as ScrollToLink } from 'react-scroll';
import { useState, useEffect } from 'react';
import cx from 'classnames';
import s from './styles.scss';
import PT from 'prop-types';
import IPT from 'react-immutable-proptypes';

export const Nav = ({ navItems, analyticsPayload, offsetRef }) => {
  const firstNavId = navItems.getIn([0, 'id']).toString();
  const [selectedId, setSelectedId] = useState(firstNavId);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const getElementHeight = () => {
      if (offsetRef.current) {
        setOffset(-offsetRef.current.clientHeight);
      }
    };

    getElementHeight();
    window.addEventListener('resize', getElementHeight);

    return () => {
      window.removeEventListener('resize', getElementHeight);
    };
  }, [offset, setOffset, offsetRef]);

  return (
    <div className={s.nav}>
      <div className={s.title}>{'Jump to:'}</div>

      {navItems.map((navItem) => (
        <div key={navItem.get('id')}>
          <ScrollToLink
            className={cx(s.navItem, {
              [s.selected]: `${navItem.get('id')}` === selectedId,
            })}
            to={`${navItem.get('id')}`}
            spy
            smooth
            duration={300}
            onSetActive={(to) => setSelectedId(to)}
            onClick={() => {
              track('question set section clicked', {
                ...analyticsPayload,
                origin: ORIGIN.QUESTION_SET,
              });
            }}
            offset={offset}
          >
            {navItem.get('title')}
          </ScrollToLink>
        </div>
      ))}
    </div>
  );
};

Nav.propTypes = {
  analyticsPayload: PT.object.isRequired,
  navItems: IPT.list.isRequired,
  offsetRef: PT.object.isRequired,
};
